import { Injectable } from '@angular/core';
import { JobsService } from './jobs.service';
import { CommonComponentStore } from '../../../shared/component-store/common-component-store';
import { JobItem } from '../../bazaar';

@Injectable({ providedIn: 'root' })
export class JobsStore extends CommonComponentStore<JobItem> {
  constructor(jobsService: JobsService) {
    super(jobsService, {
      createdId: null,
      item: null,
      items: null,
      loading: false,
      showFormModal: false,
      showPendingModal: false,
      collectionName: 'jobs',
    });
  }

  selectShowFormModal() {
    // TODO update
    // @ts-ignore
    return this.select(state => state.showFormModal);
  }

  updateShowFormModal(value) {
    // TODO update
    // @ts-ignore
    this.patchState({ showFormModal: value });
  }

  selectShowPendingModal() {
    // TODO update
    // @ts-ignore
    return this.select(state => state.showPendingModal);
  }

  updateShowPendingModal(value) {
    // TODO update
    // @ts-ignore
    this.patchState({ showPendingModal: value });
  }
}
